module.exports = __webpack_public_path__ + "static/media/application-fr.fbcd8ba6.png";